import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {App, Events, ModalController, NavController} from 'ionic-angular';
import {Observable, Subscription} from "rxjs/Rx";
import 'rxjs/add/operator/merge';

import {BtLocalService} from '../../../app/core/local-data-services/bt-local.service';
import {MeasureContextLocalService} from '../../../app/core/local-data-services/measure-context-local.service';
import {PKLocalService} from '../../../app/core/local-data-services/pk-local.service';
import {UpdateService} from '../../../app/core/update.service';
import {BT} from '../../../app/models/models';
import {BTModalPage} from '../bt-modal/bt-modal';
import {MeasureInputPage} from '../../measure-input/measure-input';
import {MeasureLocalService} from '../../../app/core/local-data-services/measure-local.service';
import {UpdatePage} from '../../update/update';
import {ThemeProvider} from "../../../providers/theme/theme";
import {MeasureService} from "../../../app/core/measure.service";
import {AppInfosService} from "../../../app/core/app-infos.service";

@Component({
  selector: 'page-bt-input',
  templateUrl: 'bt-input.html'
})
export class BTInputPage {
  bt: BT = new BT();
  missingData: boolean;
  online: boolean;
  online$: Observable<boolean>;
  onlineSubscription: Subscription;
  unsentMeasures$: Observable<number>;
  updateCheckSubscription: Subscription;
  @ViewChild("f") form;
  front_version;

  constructor(private appCtrl: App,
              private modalCtrl: ModalController,
              private navCtrl: NavController,
              private measureLocalService: MeasureLocalService,
              private pkLocalService: PKLocalService,
              private updateService: UpdateService,
              private measureService : MeasureService,
              private appInfosService: AppInfosService) {
    this.front_version = this.appInfosService.getFrontVersion();
  }

  ionViewWillEnter() {
    this.form.reset();
    this.unsentMeasures$ = this.measureLocalService.count();

    this.pkLocalService.count().subscribe(
      totalPks => {
        this.missingData = (!totalPks || (totalPks !== Number(localStorage.getItem('totalPks'))));
        if (this.missingData) {
          this.update(false);
        }
      }
    );

    BtLocalService.deleteBT();
    MeasureLocalService.deleteCurrentMeasure();
    MeasureContextLocalService.deleteCurrentMeasureContext();
    PKLocalService.deleteCurrentPk();
    PKLocalService.deletePreviousPk();
  }

  ionViewDidEnter() {
    this.online$ = Observable.merge(
      Observable.of(navigator.onLine),
      Observable.fromEvent(window, 'online').mapTo(true),
      Observable.fromEvent(window, 'offline').mapTo(false)
    );
    this.onlineSubscription = this.online$.subscribe(
      online => {
        this.online = online;
        this.getToComputeIsRunning();
      }
    );

    const updateCheckObservable = Observable.interval(30000);
    this.updateCheckSubscription = updateCheckObservable.subscribe(() => this.getToComputeIsRunning());
  }

  ionViewWillLeave() {
    this.updateCheckSubscription.unsubscribe();
    this.onlineSubscription.unsubscribe();
  }

  confirmBT() {
    let btModal = this.modalCtrl.create(BTModalPage, { bt: this.bt }, { cssClass: 'bt-modal' });

    btModal.onDidDismiss((data) => {
      if (data && data.valid === true) {
        this.startMeasure();
      }
    });

    btModal.present().then(r => r.json);
  }

  private checkUpdateNeed() {
    if (this.online) {
      this.updateService.checkUpdateNeed().subscribe(
        (updateNeeded: boolean) => updateNeeded ? this.update(false) : null
      );
    }
  }

  private getToComputeIsRunning() : any{
    return this.measureService.getToComputeIsRunning().subscribe(data => {
      if (!<boolean>data){
        this.checkUpdateNeed();
      }
    });
  }

  private startMeasure() {
    BtLocalService.setBT(this.bt.convertStringsToNumbers());
    this.navCtrl.setRoot(MeasureInputPage);
  }

  private update(manualUpdate: boolean) {
    this.appCtrl.getRootNavs()[0].setRoot(UpdatePage, { manualUpdate: manualUpdate });
  }
}



// WEBPACK FOOTER //
// ./src/pages/bt/bt-input/bt-input.ts